import brandManager from '../services/brandManager'

interface BrandValidationRule {
  name: string
  matches: (origin: string) => boolean
  brand: string
  apiUrl: string
}

const VALIDATION_RULES: BrandValidationRule[] = [
  {
    name: 'localhost',
    matches: (origin) => origin.includes('localhost:3000'),
    brand: 'onoff',
    apiUrl: 'https://onoff.besalla.com/api',
  },
  {
    name: 'agent.alanwarmodern.com',
    matches: (origin) => origin.includes('agent.alanwarmodern.com'),
    brand: 'anwar',
    apiUrl: 'https://anwar.besalla.com/api',
  },
  {
    name: 'besalla-cashier.bdaiat.com',
    matches: (origin) => origin.includes('besalla-cashier.bdaiat.com'),
    brand: 'onoff',
    apiUrl: 'https://gimi.besalla.com/api',
  },
  {
    name: 'besalla-agent.bdaiat.com',
    matches: (origin) => origin.includes('besalla-agent.bdaiat.com'),
    brand: 'onoff',
    apiUrl: 'https://gimi.besalla.com/api',
  },
]

const FALLBACK_BRAND = 'unknown'
const FALLBACK_API_URL = 'https://makbous.besalla.com/api'

export function validateBrandStartup(): void {
  if (typeof window === 'undefined') {
    return
  }

  const origin = window.location.origin
  const rule = VALIDATION_RULES.find((entry) => entry.matches(origin))

  if (rule) {
    if (
      brandManager.currentBrand !== rule.brand ||
      brandManager.apiUrl !== rule.apiUrl
    ) {
      console.warn('[BrandManager] Startup validation failed:', {
        hostname: rule.name,
        expected: { brand: rule.brand, apiUrl: rule.apiUrl },
        actual: {
          brand: brandManager.currentBrand,
          apiUrl: brandManager.apiUrl,
        },
      })
    }
    return
  }

  if (
    brandManager.currentBrand !== FALLBACK_BRAND ||
    brandManager.apiUrl !== FALLBACK_API_URL
  ) {
    console.warn('[BrandManager] Fallback validation failed:', {
      expected: { brand: FALLBACK_BRAND, apiUrl: FALLBACK_API_URL },
      actual: {
        brand: brandManager.currentBrand,
        apiUrl: brandManager.apiUrl,
      },
    })
  }
}
